<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="w-full p-5">
          <div class="flex  justify-between items-center gap-4 md:gap-6 p-2">
            <div class="flex justify-end items-center">
              <button
                @click="$router.go(-1)"
                class="bg-blues px-4 py-1 rounded-full text-sm cursor-pointer hover:bg-[#18469d] text-white"
              >
                Back
              </button>
            </div>
            <div
              class="inline-flex rounded-full border border-gray-300 overflow-hidden"
            >
              <button
                @click="setTab('list')"
                :class="[
                  'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                  tab === 'list'
                    ? 'bg-blue-100 text-blue-600'
                    : 'bg-white text-gray-600',
                ]"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>

              <button
                @click="setTab('card')"
                :class="[
                  'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                  tab === 'card'
                    ? 'bg-blue-100 text-blue-600'
                    : 'bg-white text-gray-600',
                ]"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- list -->

        <div v-if="tab === 'list'" class="px-5 lg:px-10 pb-4">
          <div class="flex items-center justify-between">
            <div>
              <h1 class="text-lg font-semibold">Assignments</h1>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer hidden">
            <p
              @click="this.submitted = 'assignment'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'assignment',
              }"
            >
              Assignments
            </p>
            <p
              @click="this.submitted = 'submitted'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'submitted',
              }"
            >
              Submitted
            </p>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="submitted === 'assignment'">
            <div v-if="assignmentInfo?.data?.length > 0" class="mt-5 space-y-4">
              <div class="w-full overflow-scroll border-b">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <!-- <th class="px-6 py-3">Name</th> -->
                      <th class="px-6 py-3">Title</th>
                      <th class="px-6 py-3">Due date</th>
                      <th class="px-6 py-3">Descrption</th>
                      <th class="px-6 py-3">Download</th>
                      <th class="px-6 py-3">Status</th>
                      <th class="px-6 py-3">Remark / Grade</th>
                      <!-- <th class="px-6 py-3">Action</th> -->
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(assignment, index) in assignmentInfo.data"
                      :key="assignment.id"
                      class="border-b pb-3"
                    >
                      <!-- <td class="px-6 py-3">
                        <img
                          class="w-20 h-16 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td> -->
                      <td class="px-6 py-3">
                        <p class="text-sm font-semibold text-gray-800">
                          {{ assignment.title }}
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <p class="text-xs text-gray-500">
                          {{ formatDate(assignment.updated_at) }}
                        </p>
                      </td>
                      <!-- {{ assignment.visibleLengths }} -->
                      <td class="px-6 py-3">
                        <p class="text-xs text-gray-600">
                          <span class="text-gray-500">{{
                            assignment.student_description.slice(
                              0,
                              assignment.visibleLengths
                            )
                          }}</span>

                          <!-- {{ assignment.visibleLengths }} -->
                          <button
                            v-if="
                              assignment.student_description.length >
                              assignment.visibleLengths
                            "
                            @click="showMore(index)"
                            class="text-blue-500 ml-2"
                          >
                            Read More
                          </button>

                          <button
                            v-if="
                              assignment.student_description.length > 50 &&
                              assignment.student_description.length <
                                assignment.visibleLengths
                            "
                            @click="showLess(index)"
                            class="text-blue-500 ml-2"
                          >
                            See Less
                          </button>
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <a :href="assignment.file" target="_blank" download>
                          <img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                          />
                        </a>
                      </td>

                      <td class="px-6 py-3">
                        <p
                          v-if="assignment.verify_status == 'submitted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="assignment.verify_status == 'accepted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else-if="assignment.verify_status == 'rejected'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid black; color: black"
                        >
                          <a class="text-black">N/A</a>
                        </p>
                      </td>
                      <td class="px-6 py-3 text-gray-500">
                        {{ assignment.remark || "-" }}
                      </td>
                      <!-- <td class="px-6 py-3" v-if="assignment">
                        <button
                          v-if="
                            !assignment.student_assignment_data ||
                            (assignment.student_assignment_data
                              ?.verify_status != 'accepted' &&
                              assignment.student_assignment_data
                                ?.verify_status != 'submitted')
                          "
                          @click="
                            this.assignmentPopup = !this.assignmentPopup;
                            this.assignmentId = assignment.id;
                          "
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'bg-gray-200 text-black cursor-not-allowed'
                              : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                          "
                          class="text-xs rounded px-3 py-1"
                        >
                          Submit
                        </button>
                        <button
                          v-else-if="
                            assignment.student_assignment_data != null && [
                              assignment.student_assignment_data
                                ?.verify_status == 'submitted' ||
                                assignment.student_assignment_data
                                  ?.verify_status == 'rejected',
                            ] &&
                            assignment.student_assignment_data?.verify_status !=
                              'accepted'
                          "
                          @click="checkAssignment(assignment)"
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'cursor-not-allowed'
                              : 'cursor-pointer text-white'
                          "
                        >
                          <img
                            src="@/assets/edit.svg"
                            alt=""
                            class="w-6 h-6 object-contain"
                          />
                        </button>
                        <p v-else>-</p>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-else class="text-gray-500 mt-5">No data found</div>
          </div>

          <div class="h-full hidden" v-else-if="submitted == 'submitted'">
            <div
              class="grid grid-cols-1 gap-10 mt-5 overflow-y-auto"
              v-if="submitassignmentInfo?.data?.length > 0"
            >
              <div class="w-full overflow-scroll border-b">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <th class="px-6 py-3">Name</th>
                      <th class="px-6 py-3">Title</th>

                      <th class="px-6 py-3">Submit date</th>
                      <th class="px-6 py-3">Aproved</th>
                      <th class="px-6 py-3">Remark / Grade</th>
                      <th class="px-6 py-3">Download</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="assignment in submitassignmentInfo.data"
                      :key="assignment"
                      class="border-b pb-3"
                    >
                      <td class="px-6 py-3">
                        <img
                          class="w-20 h-16 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <td class="px-6 py-3">
                        <p
                          class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                        >
                          {{ assignment.title }}
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          class="text-xs text-gray-600 text-left truncate mb-0"
                        >
                          Submited Date :
                          {{ formatDate(assignment.created_at) }}
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          v-if="assignment.verify_status == 'submitted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="assignment.verify_status == 'accepted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        {{ assignment.student_assignment_data?.remark || "-" }}
                      </td>
                      <td class="px-6 py-3">
                        <a :href="assignment.file" target="_blank" download
                          ><img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                        /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>No data Found</div>
          </div>
        </div>

        <!-- card -->

        <div v-else-if="tab === 'card'" class="px-5 lg:px-10 pb-4">
          <div class="flex items-center justify-between">
            <div>
              <h1 class="text-lg font-semibold">Assignments</h1>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer hidden">
            <p
              @click="this.submitted = 'assignment'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'assignment',
              }"
            >
              Assignments
            </p>
            <p
              @click="this.submitted = 'submitted'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'submitted',
              }"
            >
              Submitted
            </p>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="this.submitted == 'assignment'">
            <div
              class="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-5 gap-10 mt-5 overflow-y-auto"
              v-if="assignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in assignmentInfo?.data"
                :key="assignment"
                class="border rounded-2xl px-5 py-5 flex flex-col gap-2 md:w-full"
              >
                <div>
                  <div class="relative flex justify-center items-center">
                    <img
                      class="rounded-xl w-full"
                      src="@/assets/new/assignment.png"
                      alt=""
                    />
                  </div>
                </div>

                <div class="text-center flex flex-col gap-1 justify-center">
                  <p
                    class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                  >
                    {{ assignment.title }}
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Due Date :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                    >
                      {{ formatDate(assignment.updated_at) }}
                    </span>
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Description :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                      >{{ assignment.student_description }}
                    </span>
                  </p>

                  <div
                    class="px-1 flex items-center gap-3"
                    style="width: 100% !important"
                  >
                    <a :href="assignment.file" target="_blank" download>
                      <img
                        class="p-1 mb-1 rounded-lg"
                        style="
                          border: 1px solid #01b0f9;
                          width: 35px;
                          height: 30px;
                        "
                        src="@/assets/new/download.png"
                      />
                    </a>
                    <!-- 
                    <div
                      v-if="assignment.student_status != 'accepted'"
                      @click="checkAssignment(assignment)"
                      :disabled="assignment.student_status == 'accepted'"
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit</a>
                    </div> -->
                    <!-- <div
                      v-if="
                        assignment.student_assignment_data == null ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected' ||
                        assignment.student_assignment_data.verify_status !=
                          'submitted'
                      "
                      @click="
                        this.assignmentPopup = !this.assignmentPopup;
                        this.assignmentId = assignment.id;
                      "
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit</a>
                    </div>
                    <button
                      v-else-if="
                        assignment.student_assignment_data != null ||
                        assignment.student_assignment_data.verify_status ==
                          'submitted' ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected'
                      "
                      @click="checkAssignment(assignment)"
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'cursor-not-allowed'
                          : 'cursor-pointer text-white'
                      "
                      class="border-[1px] border-[#01b0f9] w-[35px] h-[30px] rounded-md"
                    >
                      <img
                        src="@/assets/edit.svg"
                        alt=""
                        class="w-6 h-6 object-contain mx-auto"
                      />
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
            <div v-else>No data Found</div>
          </div>

          <div class="h-full" v-else-if="submitted == 'submitted'">
            <div
              class="grid lg:grid-cols-3 2xl:grid-cols-5 gap-10 mt-5 overflow-y-auto"
              v-if="submitassignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in submitassignmentInfo.data"
                :key="assignment"
                class="border rounded-2xl px-5 py-5 flex flex-col gap-2"
              >
                <div>
                  <div class="relative flex justify-center items-center">
                    <img
                      class="rounded-xl w-full"
                      src="@/assets/new/assignment.png"
                      alt=""
                    />
                  </div>
                </div>

                <p
                  class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                >
                  {{ assignment.title }}
                </p>
                <p class="text-xs text-gray-600 text-left truncate mb-0">
                  Submited Date : {{ formatDate(assignment.created_at) }}
                </p>

                <div
                  class="px-1 flex items-center gap-3"
                  style="width: 100% !important"
                >
                  <p
                    v-if="assignment.verify_status == 'submitted'"
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #f87474; color: #f87474"
                  >
                    <a style="color: #f87474">Pending</a>
                  </p>

                  <p
                    v-else-if="assignment.verify_status == 'accepted'"
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #4bd08b; color: #4bd08b"
                  >
                    <a style="color: #4bd08b">Accepted</a>
                  </p>

                  <p
                    v-else
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #f87474; color: #f87474"
                  >
                    <a style="color: #f87474">Rejected</a>
                  </p>

                  <!-- <p
                      class="my-3 py-2 w-full text-xs rounded-lg border text-center text-black"
                    >
                      <a :href="assignment.file" target="_blank" download
                        >Download</a
                      >
                    </p>  -->

                  <div class="w-full">
                    <a :href="assignment.file" target="_blank" download
                      ><p
                        class="my-3 py-2 w-full text-xs rounded-lg border text-center text-black"
                      >
                        Download
                      </p></a
                    >
                  </div>
                </div>

                <!-- <p v-if="assignment.plagiarismcheck != null" class="rounded-xl bg-blue-400 text-white p-2 text-sm font-bold"> Plagiarism Score: {{ assignment.plagiarismcheck }}%</p> -->
              </div>
            </div>
            <div v-else>No data Found</div>
          </div>
        </div>
        <!-- assignment popup  -->
        <div
          v-if="this.assignmentPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Submit Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submitassignment"
                  @submit.prevent="scheduleAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments *</label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      required
                      accept=".txt,.doc,.docx"
                    />
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- edit assignment  -->
        <div
          v-if="this.assignmentEditPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="w-[90%] lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Update Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentEditPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submiteditassignment"
                  @submit.prevent="updateAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        v-model="assignment_title"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      v-model="assignment_des"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments *</label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      required
                      accept=".txt,.doc,.docx"
                    />
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import SideBar from "@/components/Student/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
// import confirmPopup from "@/components/confirmPopup.vue";
// import leftNavigationStudent from "@/views/studentDashboard/leftnav.vue";
// import VuePdfEmbed from "vue-pdf-embed";

export default {
  data() {
    return {
      assignmentInfo: "",
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: null,
      idpass: null,
      assignmentPopup: false,
      assignmentEditPopup: false,
      assignmentEditPopup: false,
      editvalues: null,
      assignmentId: null,
      submitassignmentInfo: null,
      submitted: "assignment",
      assignmentsNull: false,
      is_detailsPopup: false,
      assignmentDetails: null,
      is_preview: false,
      courseDetailInfo: "",
      loading: true,
      tab: "list",
      disable_submit: false,
      assignment_title: "",
      assignment_des: "",
      update_assignment: "",
    };
  },

  props: ["course_id"],

  components: {
    SideBar,
    FlashMessage,
    // confirmPopup,
    // leftNavigationStudent,
    // VuePdfEmbed,
  },

  created() {
    console.log("params", this.$route.params);
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    axios
      .get(
        `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.courseDetailInfo = response.data;
      });
    setTimeout(() => {
      this.getdetails();
    }, 200);
  },

  methods: {
    showMore(index) {
      this.assignmentInfo.data[index].visibleLengths += 50;
    },
    showLess(index) {
      // this.assignmentInfo.data[index].visibleLengths -= 100;
      this.assignmentInfo.data[index].visibleLengths = 50;
    },

    setTab(view) {
      this.tab = view;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    detailsPopup(value) {
      this.is_detailsPopup = true;
      this.assignmentDetails = value;
    },

    async getdetails() {
      if (this.$route.params.assignment_id) {
        await axios
          .get(
            `${process.env.VUE_APP_API}/student_assignment/view/?course_id=${this.course_id}&Key=${this.userInfo.token_key}&assignment_id=${this.$route.params.assignment_id}`
          )
          .then((response) => {
            this.assignmentInfo = response.data;
            this.loading = false;
            if (Object.keys(this.assignmentInfo) == "error") {
              console.log("Null");
              this.assignmentsNull = false;
            } else {
              this.assignmentsNull = true;
              // this.assignmentInfo?.data?.forEach((element) => {
              //   element["display_date"] = new Date(
              //     element.duedate
              //   ).toLocaleDateString("en-IN", {
              //     day: "numeric",
              //     month: "long",
              //     year: "numeric",
              //   });

              //   element["visibleLengths"] = 50;
              //   // map(item => ({...item,lineCount: 2}))
              // });
            }
          });
      } else {
        await axios
          .get(
            `${process.env.VUE_APP_API}/student_assignment/view/?course_id=${this.course_id}&user=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`
          )
          .then((response) => {
            this.assignmentInfo = response.data;
            this.loading = false;
            // if (Object.keys(this.submitassignmentInfo) == "error") {
            //   console.log("Null");
            // }
          });
      }
    },
    checkAssignment(assignment) {
      this.assignment_title = assignment.student_assignment_data.title;
      this.assignment_des =
        assignment.student_assignment_data.student_description;
      this.assignmentEditPopup = !this.assignmentEditPopup;
      this.assignmentId = assignment.id;
      this.update_assignment = assignment.student_assignment_data.id;
    },
    // edit assignment
    async updateAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student-assignment-student-update/${this.update_assignment}/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      formData.append("file", fileVal);
      formData.append("title", this.assignment_title);
      formData.append("student_description", this.assignment_des);

      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .put(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submiteditassignment.reset();
              this.assignmentEditPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails();
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // get assignment uploaded
    getAssignmentUploaded(id) {
      axios
        .g(
          `${process.env.VUE_APP_API}/student_assignment/new/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.getdetails();
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // student Submit Functions
    async scheduleAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student_assignment/new/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      formData.append("file", fileVal);
      formData.append("title", el.target.elements.title.value);
      formData.append(
        "student_description",
        el.target.elements.description.value
      );
      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .post(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails();
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },

    async deleteAssignment(data) {
      this.popupwindow = false;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/assignment_deleted/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "Assignment deleted successfully") {
            this.messages = {
              text: "Assignment Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      await this.getdetails();
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
